import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../config";



const initialState = {
    isLoading: false,
    categorieList: [],
    fournisseurList: [],
    tableList: [],
    userList: [],
    categorieDetails: null,
    fournisseurDetails: null,
    tableDetails: null,
    userDetails: null,
    fournisseurByCategorie: [],
    caisseRegisterHistory: [],
    caisseBalance: null,
    caisseStatus: false,
};

export const addCategorie = createAsyncThunk(
    'settings/addCategorie',
    async (formData) => {
        console.log("addCategorie", "request");
        const response = await axios.post(
            API_URL +`/api/admin/settings/addCategorie`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    }
);

export const addFournisseur = createAsyncThunk(
    'settings/addFournisseur',
    async (formData) => {
        const response = await axios.post(
            API_URL + `/api/admin/settings/addFournisseur`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }
);

export const addTable = createAsyncThunk(
    'settings/addTable',
    async (formData) => {
        console.log("addTable", "request");
        const response = await axios.post(
            API_URL + `/api/admin/settings/addTable`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }
);

export const addUsers = createAsyncThunk(
    'settings/addUsers',
    async (formData) => {
        console.log("addUsers", "request");
        const response = await axios.post(
            API_URL +`/api/admin/settings/addUsers`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const editCategorie = createAsyncThunk(
    'settings/editCategorie',
    async ({ id, formData }, thunkAPI) => {
        try {
            const response = await axios.put(
                API_URL + `/api/admin/settings/editCategorie/${id}`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la mise à jour de la catégorie:', error);
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const editFournisseur = createAsyncThunk(
    'settings/editFournisseur',
    async ({ id, formData }) => {
        console.log("editFournisseur", "request");
        const response = await axios.put(
            API_URL +`/api/admin/settings/editFournisseur/${id}`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const editTable = createAsyncThunk(
    'settings/editTable',
    async ({ tableId, formData }) => {
        console.log("editTable", "request");
        const response = await axios.put(
            API_URL +`/api/admin/settings/editTable/${tableId}`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const editUsers = createAsyncThunk(
    'settings/editUsers',
    async ({ userId, formData }) => {
        console.log("editUsers", "request");
        const response = await axios.put(
            API_URL +`/api/admin/settings/editUsers/${userId}`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const deleteCategorie = createAsyncThunk(
    'settings/deleteCategorie',
    async (categorieId) => {
        console.log("deleteCategorie", "request");
        const response = await axios.delete(
            API_URL +`/api/admin/settings/deleteCategorie/${categorieId}`,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const deleteFournisseur = createAsyncThunk(
    'settings/deleteFournisseur',
    async (fournisseurId) => {
        console.log("deleteFournisseur", "request");
        const response = await axios.delete(
            API_URL +`/api/admin/settings/deleteFournisseur/${fournisseurId}`,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const deleteTable = createAsyncThunk(
    'settings/deleteTable',
    async (tableId) => {
        console.log("deleteTable", "request");
        const response = await axios.delete(
            API_URL + `/api/admin/settings/deleteTable/${tableId}`,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const deleteUsers = createAsyncThunk(
    'settings/deleteUsers',
    async (userId) => {
        console.log("deleteUsers", "request");
        const response = await axios.delete(
            API_URL +`/api/admin/settings/deleteUsers/${userId}`,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const getAllCategories = createAsyncThunk(
    'settings/getAllCategorie',
    async () => {
        const result = await axios.get(
            API_URL +`/api/admin/settings/getAllCategories`,
        );

        return result?.data
    }
);

export const getAllFournisseurs = createAsyncThunk(
    'settings/getAllFournisseurs',
    async () => {
        const result = await axios.get(
            API_URL +`/api/admin/settings/getAllFournisseurs`,
        );

        return result?.data
    }
);

export const getAllTables = createAsyncThunk(
    'settings/getAllTable',
    async () => {
        console.log("getAllTable", "request");
        const result = await axios.get(
            API_URL + `/api/admin/settings/getAllTable`,
        );

        return result?.data
    }
);

export const getAllUsers = createAsyncThunk(
    'settings/getAllUsers',
    async () => {
        console.log("getAllUsers", "request");
        const result = await axios.get(
            API_URL +`/api/admin/settings/getAllUsers`,
        );

        return result?.data
    }
);

export const getCategorieDetails = createAsyncThunk(
    'settings/getCategorieDetails',
    async (categorieId) => {
        console.log("getCategorieDetails", "request");
        const response = await axios.get(
            API_URL +`/api/admin/settings/getCategorieDetails/${categorieId}`,
        );
        return response.data;
    }
);

export const getFournisseurDetails = createAsyncThunk(
    'settings/getFournisseurDetails',
    async (fournisseurId) => {
        console.log("getFournisseurDetails", "request");
        const response = await axios.get(
            API_URL +`/api/admin/settings/getFournisseurDetails/${fournisseurId}`,
        );
        return response.data;
    }
);

export const getTableDetails = createAsyncThunk(
    'settings/getTableDetails',
    async (tableId) => {
        const response = await axios.get(
            API_URL +`/api/admin/settings/getTableDetails/${tableId}`,
        );
        return response.data;
    }
);

export const getUserDetails = createAsyncThunk(
    'settings/getUserDetails',
    async (userId) => {
        const response = await axios.get(
            API_URL + `/api/admin/settings/getUserDetails/${userId}`,
        );
        return response.data;
    }
);

export const getFournisseurByCategorie = createAsyncThunk(
    'settings/getFournisseurByCategorie',
    async (categorieId) => {
        const response = await axios.get(
            API_URL +`/api/admin/settings/getFournisseurByCategorie/${categorieId}`,
        );
        return response.data;
    }
);

// -------------------------- CaisseRegister config -------------------------- //

export const openCaisseRegister = createAsyncThunk(
    'settings/openCaisseRegister',
    async ({ userId, formData }) => {
        const response = await axios.post(
            API_URL +`/api/admin/settings/openCaisseRegister/${userId}`,
            formData,
            { 
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
)

export const addCaisseRegister = createAsyncThunk(
    'settings/addCaisseRegister',
    async (caisseRegister) => {
        const response = await axios.post(
            API_URL +`/api/admin/settings/addCaisseRegister`,
            caisseRegister,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
)

export const retraitCaisseRegister = createAsyncThunk(
    'settings/retraitCaisseRegister',
    async ({ userId, formData }) => {
        const response = await axios.post(
            API_URL +`/api/admin/settings/retraitCaisseRegister/${userId}`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
)

export const closeCaisseRegister = createAsyncThunk(
    'settings/closeCaisseRegister',
    async ({ userId, formData }) => {
        const response = await axios.post(
            API_URL +`/api/admin/settings/closeCaisseRegister/${userId}`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
)

export const getCaisseRegisterBalance = createAsyncThunk(
    'settings/getCaisseRegisterBalance',
    async (userId) => {
        if (!userId) {
            throw new Error('Identifiant utilisateur manquant.');
        };
        const response = await axios.get(
            API_URL +`/api/admin/settings/getCaisseRegisterBalance/${userId}`,
        );
        return response.data;
    }
)

export const getCaisseRegisterHistory = createAsyncThunk(
    'settings/getCaisseRegisterHistory',
    async () => {
        const response = await axios.get(
            API_URL +`/api/admin/settings/getCaisseRegisterHistory`,
        );
        return response.data;
    }
)

export const getCaisseRegisterStatus = createAsyncThunk(
    'settings/getCaisseRegisterStatus',
    async (userId) => {
        if (!userId) {
            throw new Error('Identifiant utilisateur manquant.');
        };
        const response = await axios.get(
            API_URL +`/api/admin/settings/getCaisseRegisterStatus/${userId}`
        );
        return response.data;
    }
)





const settingsSlice = createSlice({
    name: "settings",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getAllCategories.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllCategories.fulfilled, (state, action) => {
                state.isLoading = false;
                state.categorieList = action.payload.data;
            })
            .addCase(getAllCategories.rejected, (state) => {
                state.isLoading = false;
                state.categorieList = [];
            })
            .addCase(getAllFournisseurs.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllFournisseurs.fulfilled, (state, action) => {
                state.isLoading = false;
                state.fournisseurList = action.payload.data;
            })
            .addCase(getAllFournisseurs.rejected, (state) => {
                state.isLoading = false;
                state.fournisseurList = [];
            })
            .addCase(getAllTables.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllTables.fulfilled, (state, action) => {
                state.isLoading = false;
                state.tableList = action.payload.data;
            })
            .addCase(getAllTables.rejected, (state) => {
                state.isLoading = false;
                state.tableList = [];
            })
            .addCase(getAllUsers.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllUsers.fulfilled, (state, action) => {
                state.isLoading = false;
                state.userList = action.payload.data;
            })
            .addCase(getAllUsers.rejected, (state) => {
                state.isLoading = false;
                state.userList = [];
            })
            .addCase(getCategorieDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCategorieDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.categorieDetails = action.payload.data;
            })
            .addCase(getCategorieDetails.rejected, (state) => {
                state.isLoading = false;
                state.categorieDetails = null;
            })
            .addCase(getFournisseurDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getFournisseurDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.fournisseurDetails = action.payload.data;
            })
            .addCase(getFournisseurDetails.rejected, (state) => {
                state.isLoading = false;
                state.fournisseurDetails = null;
            })
            .addCase(getTableDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getTableDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.tableDetails = action.payload.data;
            })
            .addCase(getTableDetails.rejected, (state) => {
                state.isLoading = false;
                state.tableDetails = null;
            })
            .addCase(getUserDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getUserDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.userDetails = action.payload.data;
            })
            .addCase(getUserDetails.rejected, (state) => {
                state.isLoading = false;
                state.userDetails = null;
            })
            .addCase(getFournisseurByCategorie.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getFournisseurByCategorie.fulfilled, (state, action) => {
                state.isLoading = false;
                state.fournisseurByCategorie = action.payload.data;
            })
            .addCase(getFournisseurByCategorie.rejected, (state) => {
                state.isLoading = false;
                state.fournisseurByCategorie = null;
            })
            // caisseRegister
            .addCase(getCaisseRegisterBalance.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCaisseRegisterBalance.fulfilled, (state, action) => {
                state.isLoading = false;
                state.caisseBalance = action.payload.data;
            })
            .addCase(getCaisseRegisterBalance.rejected, (state) => {
                state.isLoading = false;
                state.caisseBalance = null;
            })
            .addCase(getCaisseRegisterHistory.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCaisseRegisterHistory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.caisseRegisterHistory = action.payload.data;
            })
            .addCase(getCaisseRegisterHistory.rejected, (state) => {
                state.isLoading = false;
                state.caisseRegisterHistory = [];
            })
            .addCase(getCaisseRegisterStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCaisseRegisterStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.caisseStatus = action.payload.data;
            })
            .addCase(getCaisseRegisterStatus.rejected, (state) => {
                state.isLoading = false;
                state.caisseStatus = null;
            });
    },
});


export default settingsSlice.reducer;